var __s__ = require('./support-fns.js');
var Text2D = require('./text2d/SpriteText2D.js');
var textAlign = require('./text2d/textAlign.js');
var Jaw3DConstants = require('./jaw3d-constants.js');
var Jaw3DConnectors = require('./jaw3d-connectors.js');

/*
var THREE = require('three');

import { MTLLoader } from 'three-addons';

// https://github.com/mattdesl/three-orbit-controls
var OrbitControls = require('three-orbit-controls')(THREE);
var OBJLoader = require('three-obj-loader');
OBJLoader(THREE);
*/

//Class Renderer3D
export class Renderer3D {

    constructor(parent, w, h) {
        this.mainFont = null;
        this.scene = null;
        this.renderer = null;
        this.camera = null;
        this.raycaster = new THREE.Raycaster();
        this.mouseVector = new THREE.Vector2();
        this.controls = null;
        this.bbox = null;

        this.parent = parent;
        this.container = parent._node;
        this.width = w;
        this.height = h;
        this.frames = 0;

        this._maxX = 0;
        this._maxZ = 0;

        this._INTERSECTED = null;
        this._INTERSECTED_TOOTH = null;
        this.followMouseEvents = false;

        this._extrasInfo = new Map();
        this._extrasModels = new Map();

        this.mouseStart = new THREE.Vector2();
        this.mouseLastClick = new Date();

        this._isTakingScreenshot = false;
    }

    init() {
        let me = this,
            material,
            light,
            lightsGroup,
            mesh,
            options = this.parent.options;

        function prepareDirectionalLight(x, y, z) {
            let ll = new THREE.DirectionalLight(0xffffff, 0.25);
            ll.position.set(x, y, z);
            ll.castShadow = true;
            ll.shadow.camera.left = -19;
            ll.shadow.camera.right = 19;
            ll.shadow.camera.top = 19;
            ll.shadow.camera.bottom = -19;
            ll.shadow.camera.far = 500;
            ll.shadow.camera.near = 1;

            return ll;
        }

        if (this.container === null || this.container === undefined) { console.error("Container is null. Halting."); return; }
        if (!this.width) { console.error("Width is null or zero. Halting."); return; }
        if (!this.height) { console.error("Height is null or zero. Halting."); return; }

        this.scene = new THREE.Scene();
        this.renderer = new THREE.WebGLRenderer({
            antialias: true,
            alpha: true
        });
        this.renderer.setClearColor(options.colors.background, 1);

        this.renderer.setPixelRatio(window.devicePixelRatio);
        this.renderer.setSize(this.width, this.height);
        //this.renderer.shadowMap.enabled = true;
        //this.renderer.shadowMapSoft = true;
        this.container.divRenderC.appendChild(this.renderer.domElement);

        this.camera = new THREE.PerspectiveCamera(35, this.width / this.height, 1, 1000);
        this.camera.position.z = options.initialCameraPosition.z;
        this.camera.position.x = options.initialCameraPosition.x;
        this.camera.position.y = options.initialCameraPosition.y;

        this.controls = new THREE.OrbitControls(this.camera, this.renderer.domElement);
        this.controls.enableDamping = true;
        this.controls.dampingFactor = options.dampingFactor;
        this.controls.minPolarAngle = Math.PI / 8;
        this.controls.maxPolarAngle = Math.PI / 8 * 7;
        this.controls.maxDistance = options.initialCameraPosition.z * 2;
        this.controls.minDistance = options.initialCameraPosition.z / 2;
        this.controls.target = this.parent.__effectiveCentroid;
        this.controls.enableKeys = false;
        this.controls.enablePan = false;
        this.controls.enabled = this.parent._freeMove;

        this.raycaster = new THREE.Raycaster();
        this.mouseVector = new THREE.Vector2();

        lightsGroup = new THREE.Group();

        light = prepareDirectionalLight(-200, 300, -200);
        lightsGroup.add(light);

        light = prepareDirectionalLight(200, 300, -200);
        lightsGroup.add(light);

        light = prepareDirectionalLight(200, 300, 200);
        lightsGroup.add(light);

        light = prepareDirectionalLight(-200, 300, 200);
        lightsGroup.add(light);

        light = new THREE.DirectionalLight(0xf8f7ee, 0.05);
        light.position.set(0, -300, -50);
        lightsGroup.add(light);

        light = new THREE.AmbientLight(0xffffff, 0.86);
        light.castShadow = true;
        this.scene.add(light);

        this.scene.add(lightsGroup);

        this.followMouseEvents = this.parent._callbackMouseover || this.parent._callbackClick;
        if (this.followMouseEvents) {

            __s__.addEventLnr(this.parent._node.divRenderC, "mousemove", function(e) {
                me.mouseVector.x = (e.offsetX / me.width) * 2 - 1;
                me.mouseVector.y = -(e.offsetY / me.height) * 2 + 1;
                if(me.parent._callbackMouseover) {
                    me.parent._callbackMouseover(me._INTERSECTED_TOOTH);
                }
            });

            if(this.parent._callbackClick) {

                __s__.addEventLnr(me.parent._node.divRenderC, "mousedown", function(e) {
                    me.mouseStart = new THREE.Vector2(e.clientX, e.clientY);
                });

                __s__.addEventLnr(me.parent._node.divRenderC, "mouseup", function(e) {

                    let mouseEnd = new THREE.Vector2(e.clientX, e.clientY),
                        delta = me.mouseStart.distanceTo(mouseEnd),
                        insConnection;

                    //If the distance isn't small the user is rotating the object, not clicking it.
                    if (delta > 15) { return; }

                    //Connections
                    if (me._INTERSECTED && me._INTERSECTED.name.indexOf("cn_") === 0) {
                        let nms = me._INTERSECTED.name.split("_"),
                            t1 = me.parent.getTooth(nms[1], Jaw3DConstants.NumberFormat.UNS),
                            t2 = me.parent.getTooth(nms[2], Jaw3DConstants.NumberFormat.UNS);

                            insConnection = me._INTERSECTED.name;

                        if (!t1.isConnectedTo(t2)) {
                            t1.connect(t2);
                        } else {
                            t1.disconnect(t2);
                        }
                    }

                    //Callback. Sends 3 arguments: 1) Intersected tooth name (uns_fdi), name of object, mouse event.
                    me.parent._callbackClick(me._INTERSECTED_TOOTH,
                                             me._INTERSECTED ? me._INTERSECTED.name : "",
                                             e);


                    //doubleclick event
                    if (new Date() - me.mouseLastClick < 100) {
                        let ev = __s__.addEventDsptchr("doubleclick");
                        ev.data = { tooth: _INTERSECTED_TOOTH, connection: insConnection, name: me._INTERSECTED ? me._INTERSECTED.name : "" }
                        me.container.dispatchEvent(ev);
                    }
                    me.mouseLastClick = new Date();

                });
            }
        }

    }

    resize3DViewer (w, h) {
        if (!this.camera) { return; }
        this.width = w;
        this.height = h;
        this.camera.aspect = w / h;
        this.camera.updateProjectionMatrix();
        this.renderer.setSize(w , h);
    }

    loadStart(jawScene) {
        let me = this;

        this.loadExtrasInfo(jawScene)
            .then(this.loadModels(jawScene));
    }

    //Initial mouth-jaw loading
    loadModels(jawScene) {

        let that = this,
            node = this.container,
            loadDiv = node.loadingDiv,
            totalBytesDefault = 26 * 1024 * 1024,
            theFont = this.mainFont,
            options = this.parent.options,
            modelFiles = this.parent.modelFiles,
            REPOSITION_Y = this.parent.options.REPOSITION_Y,
            mats, mesh, matMap, rt, cm, loader, mtlLoader, objLoader, modelMap, mMapI,

            onProgress = function (xhr) {
                let percentComplete = xhr.loaded / (xhr.total || totalBytesDefault);
                loadDiv.updateLoader(percentComplete, 0.3);
            },
            onLoaded = function() {
                let ev = __s__.addEventDsptchr("modelLoaded");

                //Dispatch event
                node.dispatchEvent(ev);

                //Finish the loading div
                loadDiv.updateLoader(1, 0.5);

                //Hide the loading div
                setTimeout(function() {
                    loadDiv.hide();
                    that.animate();
                }, 500);

            },
            onError = function (xhr) {
                window.alert('An error happened loading assets');
                console.error(xhr);
            };

        function postProcessTooth(t, base) {
            let ms = t.object3D,
                bbox = new THREE.BoundingBoxHelper(ms.theCrown, 0x000000),
                xx, yy, zz,
                textMesh, line, geometry,
                prevPos, labPos, labDist,
                labelScale = options.labelScale * 0.25,
                jaw;

            jaw = jawScene[t.upper ? "upperJaw" : "lowerJaw"];
            bbox.update();
            xx = bbox.position.x;
            yy = t.upper ? 0.9 : -1.0;
            zz = bbox.position.z;
            prevPos = new THREE.Vector3(xx, yy, zz);
            t.object3D._bbox = { position: prevPos.clone() };

            //Re-position meshes (in model everything is at 0,0,0)
            ms.toothHolder.traverse(function (child) {
                child.translateOnAxis(new THREE.Vector3(1,0,0), -xx);
                child.translateOnAxis(new THREE.Vector3(0,1,0), -yy);
                child.translateOnAxis(new THREE.Vector3(0,0,1), -zz);
            });

            ms.extrasHolder.translateOnAxis(new THREE.Vector3(1,0,0), -xx);
            ms.extrasHolder.translateOnAxis(new THREE.Vector3(0,1,0), -yy);
            ms.extrasHolder.translateOnAxis(new THREE.Vector3(0,0,1), -zz);

            ms.translateOnAxis(new THREE.Vector3(1,0,0), 2 * xx);
            ms.translateOnAxis(new THREE.Vector3(0,1,0), 2 * yy);
            ms.translateOnAxis(new THREE.Vector3(0,0,1), 2 * zz);

            //Calculate Label position
            let horPos = new THREE.Vector2(
                Math.cos(Math.PI / 2 - t.obj3DInfo.piPos || 0),
                Math.sin(Math.PI / 2 - t.obj3DInfo.piPos || 0))
                .multiplyScalar(0.63);

            labPos = prevPos.clone()
                .add(new THREE.Vector3(0, 0, 2))
                .add(new THREE.Vector3(horPos.x, 0, horPos.y));

            //Create UNS Label
            textMesh = new Text2D(t.numberUNS, {
                align: textAlign.center,
                font: '32px Arial',
                fillStyle: '#000000'});

            textMesh.name = "uns_" + t.numberUNS;
            textMesh.parentTooth = "u-" + t.numberUNS + "_f-" + t.numberFDI;
            textMesh.sprite.parentTooth = "u-" + t.numberUNS + "_f-" + t.numberFDI;
            textMesh.scale.set(labelScale, labelScale, 1);
            textMesh.position.x = labPos.x;
            textMesh.position.y = (t.upper ? 0.95 : -0.7) + REPOSITION_Y;
            textMesh.position.z = labPos.z;

            // DEBUG
            jaw.group3D.labelsUns.add(textMesh);

            //Create FDI Label
            textMesh = new Text2D(t.numberFDI, {
                align: textAlign.center,
                font: '32px Arial',
                fillStyle: '#000000'});

            textMesh.name = "fdi_" + t.numberFDI;
            textMesh.parentTooth = "u-" + t.numberUNS + "_f-" + t.numberFDI;
            textMesh.sprite.parentTooth = "u-" + t.numberUNS + "_f-" + t.numberFDI;
            textMesh.scale.set(labelScale, labelScale, 1);
            textMesh.position.x = labPos.x;
            textMesh.position.y = (t.upper ? 0.85 : -0.7) + REPOSITION_Y;
            textMesh.position.z = labPos.z;

            // DEBUG
            jaw.group3D.labelsFdi.add(textMesh);

            //Previous & Next using UNS
            t.previous = Number(t.numberUNS) - 1;
            t.next = Number(t.numberUNS) + 1;
            if ((t.previous === 16 && !t.upper) || t.previous === 0)
            { t.previous = null; } else {
                t.previous = jawScene.getTooth(String(t.previous), Jaw3DConstants.NumberFormat.UNS);
            }
            if ((t.next === 17 && t.upper) || t.next === 33)
            { t.next = null; } else {
                t.next = jawScene.getTooth(String(t.next), Jaw3DConstants.NumberFormat.UNS);
            }
        }//fn-postProcessTooth

        function recenterJaw(ms, base) {
            let bbox = new THREE.BoundingBoxHelper(ms, 0x000000),
                xx, yy, zz,
                prevPos;

            bbox.update();
            xx = bbox.position.x;
            yy = bbox.position.y;
            zz = bbox.position.z;

            // console.log('recenterJaw', bbox);

            ms.myInfo = {
                myDimensions: {
                    x: Math.abs(bbox.box.max.x - bbox.box.min.x),
                    y: Math.abs(bbox.box.max.y - bbox.box.min.y),
                    z: Math.abs(bbox.box.max.z - bbox.box.min.z)
                },
                boxMin: bbox.box.min.clone(),
                boxMax: bbox.box.max.clone(),
                centroid: bbox.position.clone()
            };

            ms.holder.nameComposed = "";
            ms.holder.applyMatrix(new THREE.Matrix4().makeTranslation(0, 0, -bbox.box.min.z));
            ms.applyMatrix(new THREE.Matrix4().makeTranslation( 0, 0, bbox.box.min.z));
            ms.bbox = bbox;

            //base.add(bbox); //Add it to see the bounding box
        }//fn-recenterJaw

        function createConnectors() {
            let j, lenJ, obj, cname,
                conSet = new Set(), conn,
                jaw;

            //Creates a connector for next and previous
            for(j = 0, lenJ = jawScene._allTeeth3D.length; j < lenJ; j += 1) {
                obj = jawScene._allTeeth3D[j];
                jaw = obj.parentJaw;
                //Previous
                if (obj.previous) {
                    cname = __s__.connerctorName(obj.numberUNS, obj.previous.numberUNS);
                    if (!conSet.has(cname)) {
                        conn = new Jaw3DConnectors.Connector(cname, jaw, obj, obj.previous);
                        // Create connectors without visiblity
                        jawScene._allConnectors.set(cname, conn);
                        jaw.group3D.connectorControls.add(conn.object3d);
                        conSet.add(cname);
                    }
                }
               //Next
                if (obj.next) {
                    cname = __s__.connerctorName(obj.numberUNS, obj.next.numberUNS);
                    if (!conSet.has(cname)) {
                        conn = new Jaw3DConnectors.Connector(cname, jaw, obj, obj.next);
                        jawScene._allConnectors.set(cname, conn);
                        jaw.group3D.connectorControls.add(conn.object3d);
                        conSet.add(cname);
                    }
                }
            }
        }//fn-createConnectors

        loadDiv = this.container.loadingDiv;
        loadDiv.setPercentage(0);
        // loadDiv.setMessage("Loading model...");
        loadDiv.show();

        mtlLoader = new THREE.MTLLoader();
        mtlLoader.setBaseUrl(modelFiles.dir + "textures/");
        mtlLoader.setPath(modelFiles.dir);
        mtlLoader.load(modelFiles.mtl, function(materials) {
            let cm, loader,
                mr1 = new THREE.MeshPhongMaterial({ color: options.colors.mr1, wireframe:false, side: THREE.DoubleSide }),
                mr2 = new THREE.MeshPhongMaterial({ color: options.colors.mr2, wireframe:false, side: THREE.DoubleSide }),
                white = new THREE.MeshPhongMaterial({ color: options.colors.teeth,
                        side: THREE.DoubleSide, transparent: true, shininess: 100}),
                red = new THREE.MeshPhongMaterial({ color: 0xff0000, side: THREE.DoubleSide, transparent: true, shininess: 100  });

            materials.preload();

            matMap = {
                "MM_Object_Gums_Maxilla_2": { m: mr2, upper: 1, newName: "mr2" },
                "MM_Object_Gums_Mandibula_2": { m: mr2 , upper: 0, newName: "mr2"},
                "MM_Object_Gums_Maxilla_1": { m: mr1, upper: 1, newName: "mr1" },
                "MM_Object_Gums_Mandibula_1": { m: mr1, upper: 0 , newName: "mr1"}
            };

            modelMap = {
                "MM_Object_11_Dens_Incisivus_Primus_Superior_Lateris_Dextri_1": { tooth: "MM_Object_11", uns: "8", fdi: "11", upper: 1, crown: 1, piPos: -0.1},
                "MM_Object_11_Dens_Incisivus_Primus_Superior_Lateris_Dextri_2": { tooth: "MM_Object_11", uns: "8", fdi: "11", upper: 1},
                "MM_Object_12_Dens_Incisivus_Secundus_Superior_Lateris_Dextri_1": { tooth: "MM_Object_12", uns: "7", fdi: "12", upper: 1, crown: 1, piPos: -0.6},
                "MM_Object_12_Dens_Incisivus_Secundus_Superior_Lateris_Dextri_2": { tooth: "MM_Object_12", uns: "7", fdi: "12", upper: 1},
                "MM_Object_13_Dens_Caninus_Superior_Lateris_Dextri_1": { tooth: "MM_Object_13", uns: "6", fdi: "13", upper: 1, crown: 1, piPos: -1.1},
                "MM_Object_13_Dens_Caninus_Superior_Lateris_Dextri_2": { tooth: "MM_Object_13", uns: "6", fdi: "13", upper: 1},
                "MM_Object_14_Dens_Praemolaris_Primus_Superior_Lateris_Dextri_1": { tooth: "MM_Object_14", uns: "5", fdi: "14", upper: 1, crown: 1, piPos: -1.2},
                "MM_Object_14_Dens_Praemolaris_Primus_Superior_Lateris_Dextri_2": { tooth: "MM_Object_14", uns: "5", fdi: "14", upper: 1},
                "MM_Object_15_Dens_Praemolaris_Secundus_Superior_Lateris_Dex.000": { tooth: "MM_Object_15", uns: "4", fdi: "15", upper: 1},
                "MM_Object_15_Dens_Praemolaris_Secundus_Superior_Lateris_Dextri_": { tooth: "MM_Object_15", uns: "4", fdi: "15", upper: 1, crown: 1, piPos: -1.4},
                "MM_Object_16_Dens_Molaris_Primus_Superior_Lateris_Dextri_1": { tooth: "MM_Object_16", uns: "3", fdi: "16", upper: 1, crown: 1, piPos: -1.45},
                "MM_Object_16_Dens_Molaris_Primus_Superior_Lateris_Dextri_2": { tooth: "MM_Object_16", uns: "3", fdi: "16", upper: 1},
                "MM_Object_17_Dens_Molaris_Secundus_Superior_Lateris_Dextri_1": { tooth: "MM_Object_17", uns: "2", fdi: "17", upper: 1, crown: 1, piPos: -1.53},
                "MM_Object_17_Dens_Molaris_Secundus_Superior_Lateris_Dextri_2": { tooth: "MM_Object_17", uns: "2", fdi: "17", upper: 1},
                "MM_Object_18_Dens_Molaris_Tercius_Superior_Lateris_Dextri_1": { tooth: "MM_Object_18", uns: "1", fdi: "18", upper: 1, crown: 1, piPos: -1.57},
                "MM_Object_18_Dens_Molaris_Tercius_Superior_Lateris_Dextri_2": { tooth: "MM_Object_18", uns: "1", fdi: "18", upper: 1},
                "MM_Object_21_Dens_Incisivus_Primus_Superior_Lateris_Sinistri_1": { tooth: "MM_Object_21", uns: "9", fdi: "21", upper: 1, crown: 1, piPos: 0.1},
                "MM_Object_21_Dens_Incisivus_Primus_Superior_Lateris_Sinistri_2": { tooth: "MM_Object_21", uns: "9", fdi: "21", upper: 1},
                "MM_Object_22_Dens_Incisivus_Secundus_Superior_Lateris_Sinis.000": { tooth: "MM_Object_22", uns: "10", fdi: "22", upper: 1},
                "MM_Object_22_Dens_Incisivus_Secundus_Superior_Lateris_Sinistri_": { tooth: "MM_Object_22", uns: "10", fdi: "22", upper: 1, crown: 1, piPos: 0.6},
                "MM_Object_23_Dens_Caninus_Superior_Lateris_Sinistri_1": { tooth: "MM_Object_23", uns: "11", fdi: "23", upper: 1, crown: 1, piPos: 1.1},
                "MM_Object_23_Dens_Caninus_Superior_Lateris_Sinistri_2": { tooth: "MM_Object_23", uns: "11", fdi: "23", upper: 1},
                "MM_Object_24_Dens_Praemolaris_Primus_Superior_Lateris_Sinis.000": { tooth: "MM_Object_24", uns: "12", fdi: "24", upper: 1, crown: 1, piPos: 1.2},
                "MM_Object_24_Dens_Praemolaris_Primus_Superior_Lateris_Sinistri_": { tooth: "MM_Object_24", uns: "12", fdi: "24", upper: 1},
                "MM_Object_25_Dens_Praemolaris_Secundus_Superior_Lateris_Sin.000": { tooth: "MM_Object_25", uns: "13", fdi: "25", upper: 1},
                "MM_Object_25_Dens_Praemolaris_Secundus_Superior_Lateris_Sinistr": { tooth: "MM_Object_25", uns: "13", fdi: "25", upper: 1, crown: 1, piPos: 1.4},
                "MM_Object_26_Dens_Molaris_Primus_Superior_Lateris_Sinistri_1": { tooth: "MM_Object_26", uns: "14", fdi: "26", upper: 1, crown: 1, piPos: 1.45},
                "MM_Object_26_Dens_Molaris_Primus_Superior_Lateris_Sinistri_2": { tooth: "MM_Object_26", uns: "14", fdi: "26", upper: 1},
                "MM_Object_27_Dens_Molaris_Secundus_Superior_Lateris_Sinistri_1": { tooth: "MM_Object_27", uns: "15", fdi: "27", upper: 1, crown: 1, piPos: 1.53},
                "MM_Object_27_Dens_Molaris_Secundus_Superior_Lateris_Sinistri_2": { tooth: "MM_Object_27", uns: "15", fdi: "27", upper: 1},
                "MM_Object_28_Dens_Molaris_Tercius_Superior_Lateris_Sinistri_1": { tooth: "MM_Object_28", uns: "16", fdi: "28", upper: 1, crown: 1, piPos: 1.57},
                "MM_Object_28_Dens_Molaris_Tercius_Superior_Lateris_Sinistri_2": { tooth: "MM_Object_28", uns: "16", fdi: "28", upper: 1},
                "MM_Object_31_Dens_Incisivus_Primus_Inferior_Lateris_Sinistri_1": { tooth: "MM_Object_31", uns: "24", fdi: "31", upper: 0, crown: 1, piPos: 0.05},
                "MM_Object_31_Dens_Incisivus_Primus_Inferior_Lateris_Sinistri_2": { tooth: "MM_Object_31", uns: "24", fdi: "31", upper: 0},
                "MM_Object_32_Dens_Incisivus_Secundus_Inferior_Lateris_Sinis.000": { tooth: "MM_Object_32", uns: "23", fdi: "32", upper: 0, crown: 1, piPos: 0.2},
                "MM_Object_32_Dens_Incisivus_Secundus_Inferior_Lateris_Sinistri_": { tooth: "MM_Object_32", uns: "23", fdi: "32", upper: 0},
                "MM_Object_33_Dens_Caninus_Inferior_Lateris_Sinistri_1": { tooth: "MM_Object_33", uns: "22", fdi: "33", upper: 0, crown: 1, piPos: 0.6},
                "MM_Object_33_Dens_Caninus_Inferior_Lateris_Sinistri_2": { tooth: "MM_Object_33", uns: "22", fdi: "33", upper: 0},
                "MM_Object_34_Dens_Praemolaris_Primus_Inferior_Lateris_Sinis.000": { tooth: "MM_Object_34", uns: "21", fdi: "34", upper: 0},
                "MM_Object_34_Dens_Praemolaris_Primus_Inferior_Lateris_Sinistri_": { tooth: "MM_Object_34", uns: "21", fdi: "34", upper: 0, crown: 1, piPos: 1.0},
                "MM_Object_35_Dens_Praemolaris_Secundus_Inferior_Lateris_Sin.000": { tooth: "MM_Object_35", uns: "20", fdi: "35", upper: 0},
                "MM_Object_35_Dens_Praemolaris_Secundus_Inferior_Lateris_Sinistr": { tooth: "MM_Object_35", uns: "20", fdi: "35", upper: 0, crown: 1, piPos: 1.2},
                "MM_Object_36_Dens_Molaris_Primus_Inferior_Lateris_Sinistri_1": { tooth: "MM_Object_36", uns: "19", fdi: "36", upper: 0, crown: 1, piPos: 1.4},
                "MM_Object_36_Dens_Molaris_Primus_Inferior_Lateris_Sinistri_2": { tooth: "MM_Object_36", uns: "19", fdi: "36", upper: 0},
                "MM_Object_37_Dens_Molaris_Secundus_Inferior_Lateris_Sinistri_1": { tooth: "MM_Object_37", uns: "18", fdi: "37", upper: 0, crown: 1, piPos: 1.5},
                "MM_Object_37_Dens_Molaris_Secundus_Inferior_Lateris_Sinistri_2": { tooth: "MM_Object_37", uns: "18", fdi: "37", upper: 0},
                "MM_Object_38_Dens_Molaris_Tercius_Inferior_Lateris_Sinistri_1": { tooth: "MM_Object_38", uns: "17", fdi: "38", upper: 0, crown: 1, piPos: 1.57},
                "MM_Object_38_Dens_Molaris_Tercius_Inferior_Lateris_Sinistri_2": { tooth: "MM_Object_38", uns: "17", fdi: "38", upper: 0},
                "MM_Object_41_Dens_Incisivus_Primus_Inferior_Lateris_Dextri_1": { tooth: "MM_Object_41", uns: "25", fdi: "41", upper: 0, crown: 1, piPos: -0.05},
                "MM_Object_41_Dens_Incisivus_Primus_Inferior_Lateris_Dextri_2": { tooth: "MM_Object_41", uns: "25", fdi: "41", upper: 0},
                "MM_Object_42_Dens_Incisivus_Secundus_Inferior_Lateris_Dextri_1": { tooth: "MM_Object_42", uns: "26", fdi: "42", upper: 0, crown: 1, piPos: -0.2},
                "MM_Object_42_Dens_Incisivus_Secundus_Inferior_Lateris_Dextri_2": { tooth: "MM_Object_42", uns: "26", fdi: "42", upper: 0},
                "MM_Object_43_Dens_Caninus_Inferior_Lateris_Dextri_1": { tooth: "MM_Object_43", uns: "27", fdi: "43", upper: 0, crown: 1, piPos: -0.6},
                "MM_Object_43_Dens_Caninus_Inferior_Lateris_Dextri_2": { tooth: "MM_Object_43", uns: "27", fdi: "43", upper: 0},
                "MM_Object_44_Dens_Praemolaris_Primus_Inferior_Lateris_Dextri_1": { tooth: "MM_Object_44", uns: "28", fdi: "44", upper: 0, crown: 1, piPos: -1.0},
                "MM_Object_44_Dens_Praemolaris_Primus_Inferior_Lateris_Dextri_2": { tooth: "MM_Object_44", uns: "28", fdi: "44", upper: 0},
                "MM_Object_45_Dens_Praemolaris_Secundus_Inferior_Lateris_Dex.000": { tooth: "MM_Object_45", uns: "29", fdi: "45", upper: 0},
                "MM_Object_45_Dens_Praemolaris_Secundus_Inferior_Lateris_Dextri_": { tooth: "MM_Object_45", uns: "29", fdi: "45", upper: 0, crown: 1, piPos: -1.2},
                "MM_Object_46_Dens_Molaris_Primus_Inferior_Lateris_Dextri_1": { tooth: "MM_Object_46", uns: "30", fdi: "46", upper: 0, crown: 1, piPos: -1.4},
                "MM_Object_46_Dens_Molaris_Primus_Inferior_Lateris_Dextri_2": { tooth: "MM_Object_46", uns: "30", fdi: "46", upper: 0},
                "MM_Object_47_Dens_Molaris_Secundus_Inferior_Lateris_Dextri_1": { tooth: "MM_Object_47", uns: "31", fdi: "47", upper: 0, crown: 1, piPos: -1.5},
                "MM_Object_47_Dens_Molaris_Secundus_Inferior_Lateris_Dextri_2": { tooth: "MM_Object_47", uns: "31", fdi: "47", upper: 0},
                "MM_Object_48_Dens_Molaris_Tercius_Inferior_Lateris_Dextri_1": { tooth: "MM_Object_48", uns: "32", fdi: "48", upper: 0, crown: 1, piPos: -1.57},
                "MM_Object_48_Dens_Molaris_Tercius_Inferior_Lateris_Dextri_2": { tooth: "MM_Object_48", uns: "32", fdi: "48", upper: 0},
            };

            objLoader = new THREE.OBJLoader();
            objLoader.setPath(modelFiles.dir);
            objLoader.load(modelFiles.obj, function (object) {
                let m, loader, j, lenJ, labelsUns, labelsFdi, jaw,
                maxX = 0, maxZ = 0;

                //Iterate the 3D Model
                object.traverse(function (child) {
                    cm = matMap[child.name];
                    mMapI = modelMap[child.name];

                    //Add gums
                    if (cm && child.name) {
                        m = new THREE.Mesh(child.geometry, cm.m);
                        m.name = cm.newName;
                        m.parentTooth = "";
                        m.nameComposed = "";
                        jaw = jawScene[cm.upper ? "upperJaw" : "lowerJaw"];
                        jaw._attachMesh(m);
                        jaw[cm.newName] = m;
                    }
                    //Add teeth
                    else if (child.geometry && child.name && mMapI) {
                        mMapI = modelMap[child.name];
                        m = new THREE.Mesh(child.geometry, white.clone());
                        m.name = child.name;
                        m.isTeethPart = true;
                        m.dynamic = true;
                        jawScene._addTooth(
                            mMapI.tooth, mMapI.uns, mMapI.fdi,
                            mMapI.upper, mMapI.crown, mMapI,
                            m, white
                        );
                    }
                });

                mesh = new THREE.Object3D();
                mesh.name = "Jaws3D";
                mesh.add(jawScene.upperJaw.group3D);
                mesh.add(jawScene.lowerJaw.group3D);

                recenterJaw(jawScene.upperJaw.group3D, mesh);
                recenterJaw(jawScene.lowerJaw.group3D, mesh);

                jawScene.upperJaw.group3D.labelsUns.position.z = -2;
                jawScene.upperJaw.group3D.labelsFdi.position.z = -2;
                jawScene.lowerJaw.group3D.labelsUns.position.z = -2;
                jawScene.lowerJaw.group3D.labelsFdi.position.z = -2;

                for(j = 0, lenJ = jawScene._allTeeth3D.length; j < lenJ; j += 1) {
                    let tht = jawScene._allTeeth3D[j];
                    postProcessTooth(tht, mesh);
                    maxX = Math.max(Math.abs(tht.object3D.theCrown.position.x), maxX);
                    maxZ = Math.max(Math.abs(tht.object3D.theCrown.position.z), maxZ);
                }

                createConnectors();

                that._maxX = maxX;
                that._maxZ = maxZ + 2;

                mesh.position.x = 0;
                mesh.position.y = -(REPOSITION_Y + 0.5);
                mesh.position.z = 0;
                mesh.updateMatrix();
                mesh.matrixAutoUpdate = false;

                let bbox = new THREE.BoundingBoxHelper(mesh, 0x000000);
                bbox.update();
                that.bbox = bbox;
                //that.scene.add(bbox);

                that.scene.add(mesh);
                onLoaded();

            }, onProgress, onError);
        });
    }

    //Loads the list of extras
    loadExtrasInfo(jawScene) {
        let me = this,
            node = this.container,
            loadDiv = node.loadingDiv,
            options = jawScene.options,
            data;

        let prom = new Promise(
            function(resolve, reject) {
                let ajx = new XMLHttpRequest();
                ajx.overrideMimeType("application/json");
                ajx.open('GET', options.extraModelsJson + "?v=" + (Number(new Date())), true);
                ajx.onreadystatechange = function () {
                    let j, lenJ, data, info;
                    if (ajx.readyState === 4 && ajx.status === 200) {
                        data = JSON.parse(ajx.responseText).extras;
                        for(j = 0, lenJ = data.length; j < lenJ; j += 1) {
                            info = data[j];
                            info.dir = options.baseUrl + '/' + info.dir;
                            info.dirTextures = options.baseUrl + '/' + info.dirTextures;
                            if (me._extrasInfo.has(info.name)) { continue; }
                            me._extrasInfo.set(info.name, info);
                        }
                        resolve();
                    }
                };
                ajx.send();
            }
        );

        return prom;
    }

    //Loads the OBJ of the extra model (has a cache)
    loadExtraModel(model) {
        let me = this,
            prom,
            node = me.container,
            loadDiv = node.loadingDiv,
            onError = function(e) { console.error(e); reject(); },
            onProgress = function (xhr) {
                let percentComplete = xhr.loaded / (xhr.total || totalBytesDefault);
                loadDiv.updateLoader(percentComplete, 0.3);
            },
            onLoaded = function() {
                //Finish the loading div
                loadDiv.updateLoader(1, 0.5);

                //Hide the loading div
                setTimeout(function() {
                    loadDiv.hide();
                }, 200);
            };

        prom = new Promise(
            function(resolve, reject) {
                //If already loaded
                if(me._extrasModels.has(model.name)) {
                    resolve();
                    return;
                }

                //Load it if not
                loadDiv.setPercentage(0);
                loadDiv.setMessage("Loading part...");
                loadDiv.show();

                //1. Textures (.mtl)
                let mtlLoader = new THREE.MTLLoader();
                if (model.dirTextures) { mtlLoader.setBaseUrl(model.dirTextures); }
                mtlLoader.setPath(model.dir);
                mtlLoader.load(model.fileMtl, function(mtls) {
                    mtls.preload();

                    //2. 3D Model (.obj)
                    let objLoader = new THREE.OBJLoader();
                    objLoader.setMaterials(mtls);
                    objLoader.setPath(model.dir);
                    objLoader.load(model.fileObj, function (object) {
                        me._extrasModels.set(model.name, object);
                        onLoaded();
                        resolve();
                    }, onProgress, onError);
                });
            }
        );

        return prom;
    }

    //Puts an extra model in the place of a tooth
    insertExtraModel(tooth, name) {
        if(!this._extrasModels.has(name)) { console.error("The extra model doesn't exist."); return null; }

        let centroid = tooth.object3D._bbox.position.clone(),
            direction, matrix, v1, v2,
            extraModel = this._extrasModels.get(name).clone(),
            info = this._extrasInfo.get(name),
            gHold = new THREE.Group();

        const M_PI = Math.PI;

        v1 = new THREE.Vector2(centroid.x, centroid.z + 2);
        direction = (Math.PI / 2) - Math.atan2(v1.y, v1.x);

        extraModel.name = name;
        extraModel.parentTooth = tooth.nameComposed;
        extraModel.traverse(function(child){
            child.parentTooth = tooth.nameComposed;
        });

        //Apply the transforms (rotation, scale and translation)
        //This is the global settings for this model
        extraModel.position.x = info.translation.x;
        extraModel.position.y = info.translation.y * (tooth.upper ? 1 : -1);
        extraModel.position.z = info.translation.z;
        extraModel.scale.set(info.scale, info.scale, info.scale);
        extraModel.rotateX(info.rotation.x / 180 * M_PI * (tooth.upper ? 1 : -1));
        extraModel.rotateY(info.rotation.y / 180 * M_PI * (tooth.upper ? 1 : -1));
        extraModel.rotateZ(info.rotation.z / 180 * M_PI * (tooth.upper ? 1 : -1));

        //Apply individual transforms per specific tooth
        //In the json they are labeled as UNS
        //Everything is added to previuos position.
        //Scale is multiplied, i.e., it should be 1 to have the same scale.
        if(info.perToothExtraTransforms && info.perToothExtraTransforms[tooth.numberUNS]) {

            let ttfs = info.perToothExtraTransforms[tooth.numberUNS],
                nScale = info.scale * ttfs.scale;

            extraModel.position.x += ttfs.translation.x;
            extraModel.position.y += ttfs.translation.y * (tooth.upper ? 1 : -1);
            extraModel.position.z += ttfs.translation.z;
            extraModel.scale.set(nScale, nScale, nScale);
            extraModel.rotateX(ttfs.rotation.x / 180 * M_PI * (tooth.upper ? 1 : -1));
            extraModel.rotateY(ttfs.rotation.y / 180 * M_PI * (tooth.upper ? 1 : -1));
            extraModel.rotateZ(ttfs.rotation.z / 180 * M_PI * (tooth.upper ? 1 : -1));
        }

        gHold.add(extraModel);
        gHold.rotation.y = direction;
        gHold.name = name;

        tooth.object3D.extrasHolder.add(gHold);

        //Dispatch event
        let ev = __s__.addEventDsptchr("updateModel");
        ev.tooth = tooth;
        this.container.dispatchEvent(ev);

        //Return the extraModel 3D object
        return gHold;
    }

    animate() {
        var me = this;

        function anim() {
            requestAnimationFrame(anim);
            me.controls.update();
            me.render();
        }
        anim();
    }

    render() {

        if (this._isTakingScreenshot) { return; }

        this.frames += 1;

        if (this.followMouseEvents && this.frames & 1) { //this.frames & 1 - only odd frames
            this.raycaster.setFromCamera(this.mouseVector.clone(), this.camera);

            let intersects = this.raycaster.intersectObjects(this.scene.children, true),
                lenI = intersects.length;

            if (lenI > 0) {
                let intersect0 = intersects[0].object;

                if (intersect0 !== this._INTERSECTED) {
                    let ev = __s__.addEventDsptchr("pointerchanged");
                    this.container.dispatchEvent(ev);
                    this._INTERSECTED = intersect0;
                    this._INTERSECTED_TOOTH = intersect0.parentTooth;
                }
            } else {
                let ev = __s__.addEventDsptchr("pointerchanged");
                this.container.dispatchEvent(ev);
                this._INTERSECTED = null;
                this._INTERSECTED_TOOTH = null;
            }
        }

        this.renderer.render(this.scene, this.camera);
    }

    onDocumentMouseMove(e) {
        this.mouseVector.x = (e.clientX / me.width) * 2 - 1;
        this.mouseVector.y = -(e.clientY / me.height) * 2 + 1;
    }

    onNodeMouseClick(e) {
        console.log(this.mouseVector);
    }
}
